module.exports = __webpack_public_path__ + "img/digital_platform_1.e486a586.png";